import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

interface CTAItem {
  label: string;
  href: string;
  type: "primary" | "secondary" | "ghost";
}

interface InfoPageFinalCTAProps {
  title: string;
  subtitle?: string;
  ctas: CTAItem[];
}

export default function InfoPageFinalCTA({
  title,
  subtitle,
  ctas,
}: InfoPageFinalCTAProps) {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden bg-airdoa-navy">
      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold text-white leading-tight whitespace-pre-line">
              {title}
            </h2>
            {subtitle && (
              <p className="mt-5 text-sm md:text-base text-white/70">
                {subtitle}
              </p>
            )}
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              {ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link
                      key={cta.href}
                      to={cta.href}
                      className="btn-primary w-full sm:w-auto justify-center"
                    >
                      {cta.label}
                    </Link>
                  );
                }
                if (cta.type === "secondary") {
                  return (
                    <Link
                      key={cta.href}
                      to={cta.href}
                      className="btn-secondary w-full sm:w-auto justify-center"
                    >
                      {cta.label}
                    </Link>
                  );
                }
                return (
                  <Link
                    key={cta.href}
                    to={cta.href}
                    className="btn-ghost w-full sm:w-auto justify-center"
                  >
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}